export default __webpack_public_path__ + "locales/events.kk.json";